import { Type } from '@angular/core';

export class DialogParams<
  T extends { [key: string]: any } = { [key: string]: any }
> {
  component?: Type<any>;
  title?: string = '';
  text?: string = '';
  confirmButtonText?: string = '';
  rejectButtonText?: string = '';
  maxContentHeightRem?: number;
  confirmButtonType?: 'confirm' | 'warn' = 'confirm';
  rejectButtonType?: 'confirm' | 'warn' = 'confirm';
  data?: T;
  price?: {
    for: string;
    amount: number;
    explicit?: boolean;
  };
  disableClose?: boolean;

  constructor(dialogParams: DialogParams<T>) {
    Object.assign(this, dialogParams);
  }
}
